import InfoSecurity from "../components/Agreement/InfoSecurity";
import Oferta from "../components/Agreement/Oferta";
import PrivacyPolicy from "../components/Agreement/PrivacyPolicy";

const Agreement = () => {
  return (
    <>
      <Oferta />
      <InfoSecurity />
      <PrivacyPolicy />
    </>
  );
};

export default Agreement;
